module.exports = __webpack_public_path__ + "static/media/slide_1.5ae77c26.jpg";